import Component from "vue-class-component";
import Ribbon from "@/core/ribbon/ribbon.vue";
import JhiFooter from "@/core/jhi-footer/jhi-footer.vue";
import JhiNavbar from "@/presentation/containers/header/header.container.vue";
import JhiNavbars from "@/core/jhi-navbar/jhi-navbar.vue";
import BaseComponent from "@/presentation/BaseComponent";
import AppMain from "@/presentation/view/resources/appMain.vue";
@Component({
  components: {
    ribbon: Ribbon,
    "jhi-navbar": JhiNavbar,
    "jhi-navbars": JhiNavbars,
    "jhi-footer": JhiFooter,
    "app-main": AppMain,
  },
})
export default class App extends BaseComponent {}
